import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ReactDragList from 'react-drag-list';
import { refreshToken, APIRoot, content_admin } from 'variables/authentication.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// TOOD: replace cloneDeep with ramda 
import cloneDeep from 'lodash/cloneDeep';
import formurlencoded from 'variables/urlencode';
import Api from 'services/api';
import * as R from 'ramda';

//dev
const GamesAPIRoot = APIRoot + "/games";
// const CameraWheelElementsAPIRoot = APIRoot + "/client-versions";
const CameraWheelElementsAPIResourceRoot = APIRoot + "/client-versions";


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  dragElement: {
    marginLeft: theme.spacing.unit,
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  nested: {
    minWidth: 200,
    maxWidth: 400 + 2 * theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
  },
  dragList: {
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  submit: {
    width: 200,
    height: 50,
    marginTop: 15,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  delete: {
    marginRight: theme.spacing.unit,
  },
  listItemText: {
    fontSize: '1.0em',//Insert your required size
  }
});

const modes = {
  EDIT: 'edit',
  NEW: 'new',
  VIEW: 'view'
}

const platforms = [
  {
    value: 'ios',
    label: 'IOS',
  },
  {
    value: 'android',
    label: 'ANDROID',
  },
];

const is_live = [
  {
    value: true,
    label: 'True',
  },
  {
    value: false,
    label: 'False',
  },
]

class WheelsForm extends React.Component {
  constructor(props) {
    super(props);
    this.switchMode = props.switchMode;
    this.getMode = props.getMode;
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.state = {
      open: false,
      // TOOD: replace cloneDeep with ramda 
      data: props.getMode() == modes.EDIT ? cloneDeep(props.row_data) : { device_type: 'ios', is_live: false, client_games: [] },
      gamePool: []
    };
    // this.loadGamePool = this.loadGamePool.bind(this);
    // this.handleAppend = this.handleAppend.bind(this);
    this.loadGamePool();
  }

  async loadGamePool(secondChance = true) {


    try {
      let games = await Api({ endpoint: '/games', headers: { "Content-Type": "application/x-www-form-urlencoded" } });

      // create an object keyed by unity_commands
      let groupByUnityCommand = R.groupBy(R.prop('unity_command'));

      const objectIdtoNum = x => Number(x.replace('objectID', ''))
      const objectIdDesc = (a, b) => objectIdtoNum(a.firestore_object_id) > objectIdtoNum(b.firestore_object_id) ? -1 : 1;
      // make sure each value in the object is only the game with the latest firestore_object_id
      const sortGames = (uniityGames, key, obj) => R.sort(objectIdDesc, uniityGames)[0];
      const sortUnityGamesByObjectId = R.mapObjIndexed(sortGames);

      const latestGamesObj = sortUnityGamesByObjectId(groupByUnityCommand(games));
      // sort array of object values aplphabetically by display_name
      const sortByDisplayName = R.sortBy(R.compose(R.toLower, R.prop('display_name')));

      this.setState({
        gamePool: sortByDisplayName(Object.values(latestGamesObj))
      })
    } catch (e) {
      console.error(e)
    }

  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = name => event => {
    var data = this.state.data;
    data[name] = event.target.value;
    this.setState({ data: data });
  };

  handleAppend = event => {
    var data = this.state.data;
    data.client_games = data.client_games.concat([{ game: event.target.value }]);
    this.setState({ data: data });
  }

  handleRemove = index => event => {
    var data = this.state.data;
    data.client_games.splice(index, 1);
    this.setState({ data: data });
  }

  handleCancel() {
    this.setState({ data: { client_games: [] } });
    this.switchMode(modes.VIEW);
  }

  async handleSubmit() {
    // update wheel ordering
    var data = this.state.data;

    for (let key in data.client_games) {
      data.client_games[key].display_index = key;
    }
    const { version_major, version_minor, version_patch } = this.state.data;


    try {
      debugger;
      // Create or Update a client_version including client_games
      const editedClientVersion = await Api({
        endpoint: `/client-versions${this.getMode() == modes.EDIT ? `/${data.id}` : ""}`,
        method: this.getMode() == modes.EDIT ? 'PUT' : 'POST',
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formurlencoded(data)
      })

      this.switchMode(modes.VIEW, true);
    } catch (e) {
      console.error(e)
    }

  }

  async handleDelete() {
    try {
      const { data: { id: versionID } } = this.state;
      const deletedVersion = await Api({
        endpoint: `/client-versions/${versionID}`,
        method: 'DELETE',
      });

      this.switchMode(modes.VIEW, true);
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div >
        <form className={classes.container} noValidate autoComplete="off">
          <TextField
            id="standard-select-device_type"
            select
            required
            label="Platform"
            className={classes.textField}
            value={this.state.data.device_type || 'ios'}
            onChange={this.handleChange('device_type')}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}

            margin="normal"
          >
            {platforms.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="standard-select-is_live"
            select
            required
            label="Is Live"
            className={classes.textField}
            value={this.state.data.is_live || false}
            onChange={this.handleChange('is_live')}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}

            margin="normal"
          >
            {is_live.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            id="standard-version-major"
            label="Version Major"
            required
            value={this.state.data.version_major}
            onChange={this.handleChange('version_major')}
            type="number"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
          />
          <TextField
            id="standard-version-minor"
            label="Version Minor"
            required
            value={this.state.data.version_minor}
            onChange={this.handleChange('version_minor')}
            type="number"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
          />
          <TextField
            id="standard-version-patch"
            label="Version Patch"
            required
            value={this.state.data.version_patch}
            onChange={this.handleChange('version_patch')}
            type="number"
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
          />

        </form>

        <div>
          <ReactDragList
            dataSource={this.state.data.client_games}
            rowKey="title"
            row={(record, index) => (
              <div className={classes.dragList} key={record.id} style={{ color: "inherit" }}>
                <Button variant="outlined" className={classes.dragElement}>
                  {record.game.unity_command}
                </Button >
                <IconButton onClick={this.handleRemove(index)}>
                  <DeleteIcon />
                </IconButton>


              </div>
            )}
            handles={false}
            className={classes.dragList}
            rowClassName="simple-drag-row"
          />
          <TextField
            id="standard-select-game"
            select
            label="Add Game"
            className={classes.nested}
            value={""}
            onChange={this.handleAppend}
            SelectProps={{
              MenuProps: {
                className: classes.menu,
              },
            }}

            margin="normal"
          >
            {this.state.gamePool.map(option => (
              <MenuItem key={option.id} value={option}>
                {option.unity_command}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <Button
          variant="contained"
          color="inherit"
          className={classes.submit}

          onClick={this.handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.submit}
          // TODO: replace this with a ui warning or role based routing 
          disabled={localStorage.getItem('role') != content_admin}
          onClick={this.handleSubmit}
        >
          Save
        </Button>
        <div>
          {this.props.getMode() == modes.EDIT ?
            <Button
              variant="text"
              color="secondary"
              className={classes.submit}
              disabled={localStorage.getItem('role') != content_admin}
              onClick={this.handleClickOpen}>
              Delete this Version
        </Button>
            :
            <></>}

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Delete This Version?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You are about to delete camera wheel element version
              {" " + this.state.data.device_type.toUpperCase() + " " + this.state.data.version_major + "." + this.state.data.version_minor + "." + this.state.data.version_patch}.
                                                                                                                                                                                                          Deleted versions will not be able to be recovered.
            </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancel
            </Button>
              <Button onClick={this.handleDelete} color="secondary" autoFocus>
                Delete
            </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

WheelsForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WheelsForm);